import React, { useState } from "react";
import styles from "../../styles/Select.module.css";
import { OptionsProps } from "./Popup/UploadModal";
import { ActionButton, ArrowWrapper } from "../../styles/Button.styled";
import { Arrow } from "../../../public/icons";

interface SelectProps {
  label: string;
  value: string | undefined;
  options: OptionsProps[];
  onChange: (opt: OptionsProps) => void;
  disabled?: boolean;
  style?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
}

export const Select: React.FC<SelectProps> = ({
  label,
  value,
  options = [],
  onChange,
  disabled,
  style,
  labelStyle,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedOption = Array.isArray(options)
    ? options.find((opt) => opt.id === value)
    : null;

  const allowOptions = options.length > 0;
  const hasValue = !!selectedOption;
  const isFloating = isOpen || hasValue;

  const labelColor = disabled 
    ? "var(--disabled-btn-bg)" 
    : (isOpen ? "var(--blue)" : "var(--black)");

  const borderColor = disabled 
    ? "var(--disabled-btn-bg)" 
    : (isOpen ? "var(--blue)" : "var(--disabled-c)");

    const textColor = disabled ? "var(--disabled-btn-bg)" : "var(--black)";

  return (
    <div className={styles.formControl} style={style}>
      <div className={styles.selectWrapper}>
        <button
          type="button"
          disabled={disabled}
          className={styles.select}
          onClick={() => setIsOpen(!isOpen)}
          onBlur={() => setIsOpen(false)}
          // style={{
          //   color: selectedOption ? "var(--black)" : "transparent",
          // }}
          style={{
            textAlign: "left",
           color: textColor,
            borderColor: borderColor,
            cursor: disabled ? "default" : "pointer",
            opacity: 1, 
          }}
        >
          {selectedOption?.title ?? ""}
        </button>

        <label
          style={{
            position: "absolute",
            left: "10px",
            top: isFloating ? "-8px" : "50%",
            color: labelColor,
            transform: isFloating ? "translateY(0)" : "translateY(-50%)",
            padding: "0 4px",
            fontSize: isFloating ? "12px" : "14px",
            background: isFloating
              ? "linear-gradient(to bottom, var(--background) 40%, white 60%)"
              : "transparent",
            pointerEvents: "none",
            zIndex: 1,
            fontWeight: isFloating ? 700 : 500,
            transition:
              "top 0.2s ease, font-size 0.2s ease, color 0.2s ease, transform 0.2s ease",
            whiteSpace: "nowrap",
            ...labelStyle,
          }}
        >
          {label}
        </label>
        <div
          style={{
            position: "absolute",
            top: 10,
            right: 10,
          }}
        >
          {!disabled && (
            <ActionButton
              type="button"
              $hasOffset={options.length > 0}
              onClick={() => setIsOpen(true)}
              aria-label={"Відкрити список"}
            >
              <ArrowWrapper $isOpen={isOpen}>
                <Arrow color="var(--disabled-c)" />
              </ArrowWrapper>
            </ActionButton>
          )}
        </div>

        {isOpen && allowOptions && (
          <ul className={styles.dropdown}>
            {options.map((opt) => (
              <li key={opt.id ?? opt.title}>
                <button
                  type="button"
                  className={`${styles.account_btn} ${opt.id === value ? styles.selected : ""}`}
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => {
                    onChange(opt);
                    setIsOpen(false);
                  }}
                >
                  {opt.title}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
